module.exports = __webpack_public_path__ + "static/products-grid3-95424a081ffe82635d22b755ce7ec986.jpg";